import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  forgetUnavailablePackChoice,
  productParameters,
  pledgeProductHasPacks,
  withSequentialSuffixes,
} from '../../pledge-pack-choice';

@UntilDestroy()
@Component({
    selector: 'investment-allocation',
    templateUrl: './investment-allocation.component.html',
    styleUrls: ['./investment-allocation.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class InvestmentAllocationComponent implements OnInit {
  freeOption: FormControlOption = {
    label: 'Choix libre',
    value: 'FREE',
    suffix: 'A',
    svg: 'free-choice.svg',
  };
  packOption: FormControlOption = {
    label: 'Choisir un pack',
    value: 'PACK',
    suffix: 'B',
    svg: 'package-choice.svg',
  };
  pilotedOption: FormControlOption = {
    label: 'Mandat de gestion',
    value: 'PILOTED',
    suffix: 'C',
    svg: 'driven-managment.svg',
  };
  options: FormControlOption[] = withSequentialSuffixes([
    this.freeOption,
    this.pilotedOption,
  ]);

  constructor(
    private simulationDao: SimulationDao,
    private subscriptionFacade: SubscriptionFacadeService,
    private controlContainer: ControlContainer,
  ) {}

  ngOnInit() {
    pledgeProductHasPacks(this.simulationDao, this.subscriptionFacade.getPledge())
      .pipe(untilDestroyed(this))
      .subscribe(hasPacks => {
        if (hasPacks) {
          this.options = withSequentialSuffixes([
            this.freeOption,
            this.packOption,
            this.pilotedOption,
          ]);
        } else if (hasPacks === false) {
          forgetUnavailablePackChoice(
            this.controlContainer.control,
            'avDistribution',
            this.subscriptionFacade,
            productParameters,
          );
        }
      });
  }
}
